//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			list: [],
			showQuestion: false,
			showMask: false,
			page: {
				pageSize: 10,
				currentPage: 1,
				sortType: '4',
				count: 0,
				loading: false,
			},
			integral: ''
		}
	},
	onShow() {
		this.userIntegral()
		this.queryData()
	},
	onPullDownRefresh() {
		this.list = []
		this.page.currentPage = 1
		this.queryData('refresh')
	},
	onReachBottom() {
		if (this.list.length < this.page.count) {
			this.queryData()
		}
	},
	methods: {
		handleClick() {
			uni.navigateTo({
				url: '/pages/personalCenter/myIntegral/integralDetails'
			})
		},
		confirm() {
			this.showMask = false
			setTimeout(() => {
				this.showQuestion = false
			}, 150)
		},
		Question() {
			this.showMask = true
			setTimeout(() => {
				this.showQuestion = true
			}, 150)
		},
		conversion(t) {
			let _this = this
			this.$ajax({
				method: 'post',
				url: '/weChat/integrals/member/selectByMemberId',
				data: {
					memberId: this.$store.state.userInfo.memberId
				}
			}).then(res => {
				this.integral = res.data
				if (this.integral >= t.needIntegrals) {
					uni.showModal({
						title: t.productName,
						content: '商品一经兑换不可退换，确定兑换吗?',
						success(res) {
							if (res.confirm) {
								_this.$ajax({
									method: 'post',
									url: '/weChat/integrals/member/exchage',
									data: {
										memberId: _this.$store.state.userInfo.memberId,
										id: t.id
									}
								}).then(res => {
									uni.navigateTo({
										url: '/pages/personalCenter/myIntegral/success'
									})
								})
							}
						}
					})
				} else {
					uni.showToast({
						title: '积分不足',
						icon: 'none'
					})
				}
			})
		},
		//用户积分获取
		userIntegral() {
			this.$ajax({
				method: 'post',
				url: '/weChat/integrals/member/selectByMemberId',
				data: {
					memberId: this.$store.state.userInfo.memberId
				}
			}).then(res => {
				this.integral = res.data
			})
		},
		// 列表获取
		queryData(status) {
			this.page.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/integrals/mall/selectToWeChat',
				data: {
					...this.page,
				}
			}).then(res => {
				this.list.push.apply(this.list, res.data.list)
				this.page.loading = false
				this.page.count = res.data.total
				if (this.list.length >= this.page.count) {
					this.end = true
				}
				this.page.currentPage += 1
				if (status === 'refresh') {
					uni.stopPullDownRefresh();
				}
			})
		},
	}
}
